import { render, staticRenderFns } from "./laporan_tunggakan.vue?vue&type=template&id=14e60240&"
import script from "./laporan_tunggakan.vue?vue&type=script&lang=js&"
export * from "./laporan_tunggakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports